<template>
  <div class="container image-block image-sequence">
    <div class="sequence-container" :class="{ fade: moduleData.settings.transition == 'fade' }">
      <img
        v-for="(link, index) in moduleData.settings.links"
        :key="`${link}-${index}`"
        :src="link"
        :alt="`Frame ${index}`"
        :class="{ active: index <= currentImage }"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    moduleData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      counter: null,
      currentImage: 0
    }
  },
  mounted () {
    this.counter = setInterval(() => {
      if (this.currentImage < this.moduleData.settings.links.length-1) {
        this.currentImage++
      } else {
        this.currentImage = 0
      }
    }, this.moduleData.settings.rate)
  },
  beforeDestroy () {
    clearInterval(this.counter)
  }
}
</script>

<style lang="scss" scoped>
.sequence-container {
  position: relative;

  &.fade img {
    transition: .5s opacity;
  }
}
img {
  width: 100%;
  opacity: 0;
  &.active {
    opacity: 1;
  }
  &:not(:first-child) {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>